import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    source: null,
    destination: null,
    isDestinationOptional: false,
};

const templatesSlice = createSlice({
    name: "templates",
    initialState,
    reducers: {
        setTemplate: (state, action) => ({
            ...action?.payload,
        }),
        clearTemplate: () => ({
            ...initialState,
        }),
    },
});

export const { setTemplate, clearTemplate } = templatesSlice.actions;
export default templatesSlice.reducer;
